import React, { Component, PropTypes } from 'react';
import { hashHistory } from 'react-router';
import locales from '../../../config/locales';
import styles from './search-results.scss';
import CSSModules from 'react-css-modules';
import Icon from '../shared/Icon';
import ContentHeader from '../shared/ContentHeader';
import DetailHeader from '../shared/DetailHeader';
import { getCurrentLanguage, getSearchFields } from '../../localData';
import Objects from './Objects';
import Persons from './Persons';
import settings from '../../../config/settings';

class SearchResults extends Component {
    static propTypes = {
        store: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.isRedirecting = false;
    }

    l = (key) => (
        locales[getCurrentLanguage()].components.SearchResults[key]
    );

    componentWillMount() {
        this.redirectToObject(this.props.store.objects, this.props.store.designers, this.props.store.producers);
    }

    componentWillReceiveProps(nextProps) {
        this.redirectToObject(nextProps.store.objects, nextProps.store.designers, nextProps.store.producers);
    }

    redirectToObject = (objects, designers, producers) => {
        if (
            objects.edges.length === 1
            && !designers.edges.length
            && !producers.edges.length
        ) {
            this.isRedirecting = true;
            const object = objects.edges[0].node;
            hashHistory.push(`/${getCurrentLanguage()}/object/${object.id}`);
        }
    };

    shouldComponentUpdate() {
        return !this.isRedirecting;
    }

    render() {
        const { objects, designers, producers } = this.props.store;
        const isSearchingForPersons = () => { return !!getSearchFields().searchPerson; };
        const isSearchingSimple = () => { return !!getSearchFields().searchQuery; }
        const icon = <Icon icon="Vitra_Search.svg" />;

        return (
            <div styleName="container">
                <DetailHeader
                    relay={ this.props.relay }
                    detail={{
                        icon: icon,
                        title: this.l('title'),
                    }}
                    simple
                />
                <div id="detailHeader">
                    <ContentHeader
                        title={ this.l('title') }
                        icon={ icon }
                    />
                </div>
                <div className="page-content">
                    {
                        !!settings.searchResults.showObjects &&
                        <Objects
                            objects={objects}
                            title={ this.l('objects')}
                            lang={getCurrentLanguage()}
                        />
                    }
                    {
                        (!!settings.searchResults.showDesigners && (isSearchingForPersons() || isSearchingSimple())) &&
                        <Persons
                            persons={designers}
                            title={ this.l('designers')}
                            lang={getCurrentLanguage()}
                        />
                    }
                    {
                        (!!settings.searchResults.showProducers &&(isSearchingForPersons() || isSearchingSimple())) &&
                        <Persons
                            persons={producers}
                            title={ this.l('producers')}
                            lang={getCurrentLanguage()}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default CSSModules(SearchResults, styles);



// WEBPACK FOOTER //
// ./app/components/SearchResults/SearchResults.jsx